import React from 'react';
import {
  ChartTitleContainer,
  TitleInput,
} from '@/features/dashboard/components/ChartTitle/ChartTitle.styles';
import { WIDGET_NAME_INPUT } from '@/constants/test-ids';
import { useUpdateChartTitle } from './useUpdateChartTitle';

export const ChartTitle: React.FC = () => {
  const [isShown, title, updateTitle] = useUpdateChartTitle();

  if (!isShown) return null;

  return (
    <ChartTitleContainer>
      Chart title
      <TitleInput
        data-testid={WIDGET_NAME_INPUT}
        value={title}
        onChange={updateTitle}
      />
    </ChartTitleContainer>
  );
};
